// Copyright (c) 2021 WiseTime. All rights reserved.

export const RECENT_LIST_ACTIVITY_TYPES_COUNT = 20
export const RECENT_LIST_TAGS_COUNT = 40
export const SEARCH_LIST_ITEM_COUNT = 100
